// Stop video when the modal closes

(jQuery)(function($) {
    $('.modal' ).on('hide.bs.modal', function (e) {
        var $iframe = $(this ).find('iframe');
        $iframe.attr('src', $iframe.attr("src"));
    });
});